import { render, staticRenderFns } from "./helloTong.vue?vue&type=template&id=41eeaa6a&scoped=true"
import script from "./helloTong.vue?vue&type=script&lang=ts"
export * from "./helloTong.vue?vue&type=script&lang=ts"
import style0 from "./helloTong.vue?vue&type=style&index=0&id=41eeaa6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41eeaa6a",
  null
  
)

export default component.exports